import React from 'react';

/**
 * Memoized component wrapper for consistent styling
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} Component wrapper
 */
const ComponentWrapper = React.memo(({ children }) => (
  <div style={{ 
    width: "100%",
    height: "100%",
    overflow: "hidden",
  }}>
    {children}
  </div>
));

ComponentWrapper.displayName = 'ComponentWrapper';

export default ComponentWrapper;
